import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { ClientId, DateSchema, FartherAccountId, PerformanceGroupId, PortfolioId, } from "../../Types";
import ValidationError from "../../ZodError";
const GroupType = z.enum([
    "ALL_CLIENT_ACCOUNTS",
    "SINGLE_CLIENT_ACCOUNT",
    "CUSTOM",
]);
const vendorDetails = z.object({
    portfolioId: PortfolioId,
    dataReportingVendor: z.string(),
});
export const AccountGroup = z.object({
    accountGroupId: PerformanceGroupId,
    ownerId: ClientId,
    accountGroupType: GroupType,
    displayName: z.string(),
    virtualAccountIds: FartherAccountId.array(),
    isFavorite: z.boolean(),
    vendorDetails: vendorDetails,
    createTime: DateSchema,
    modifyTime: DateSchema,
});
export const url = (accountGroupId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/account-groups/v4/account-groups/${accountGroupId}`
        : `https://middleware.uat.farther.com/account-groups/v4/account-groups/${accountGroupId}`;
};
export default async function getSingleAccountGroupV4(accountGroupId, config) {
    const { data } = await axios.get(url(accountGroupId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = AccountGroup.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "getSingleAccountGroupV4 returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getSingleAccountGroupV4.js.map